import React from "react";

import cx from "classnames";

import { CardBody } from "./card-body";
import { CardFooter } from "./card-footer";
import { CardHeader } from "./card-header";

export interface CardProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  displayHorizontalPadding?: boolean;
  displayVerticalPadding?: boolean;
}

export interface Card {
  Header: typeof CardHeader;
  Body: typeof CardBody;
  Footer: typeof CardFooter;
}

export const Card: React.FC<React.PropsWithChildren<Readonly<CardProps>>> & Card = ({
  className,
  displayHorizontalPadding = true,
  displayVerticalPadding = true,
  children,
  ...props
}) => (
  <div
    {...props}
    className={cx(
      "bg-white shadow-lg rounded-lg overflow-hidden",
      {
        "px-6 md:px-12": displayHorizontalPadding,
        "py-6 md:py-8": displayVerticalPadding,
      },
      className,
    )}
  >
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
